export default __webpack_public_path__ + "6ec820908cfaefc1472664fe1a4319bd.png";